import { render, staticRenderFns } from "./MigrateBankList.vue?vue&type=template&id=143b838c&"
import script from "./MigrateBankList.vue?vue&type=script&lang=js&"
export * from "./MigrateBankList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports